import React from 'react'
import { Form } from 'react-bootstrap'
import { useI18n } from '../../i18n/I18nProvider'
import {
  ModuleVisibility,
  UserModule,
} from '../../domains/Settings/config/userModules'
import styles from './PrivateModePanel.module.scss'

interface PrivateModePanelProps {
  isPrivateModeActive: boolean
  modules: UserModule[]
  saving?: boolean
  onToggle: (isActive: boolean) => void
  onVisibilityChange: (code: string, visibility: ModuleVisibility) => void
  onSetAllVisibility: (visibility: ModuleVisibility) => void
}

const PrivateModePanel = ({
  isPrivateModeActive,
  modules,
  saving = false,
  onToggle,
  onVisibilityChange,
  onSetAllVisibility,
}: PrivateModePanelProps) => {
  const { t } = useI18n()
  const visibilityOptions: { label: string; value: ModuleVisibility }[] = [
    { label: t('Public'), value: 'public' },
    { label: t('Private'), value: 'private' },
  ]
  const allPublic = modules.every(
    (moduleItem) => moduleItem.visibility === 'public',
  )
  const allPrivate = modules.every(
    (moduleItem) => moduleItem.visibility === 'private',
  )

  return (
    <div className={styles.root}>
      <Form.Check
        type="switch"
        id="profile-private-mode-active"
        label={t('Enable private mode for this user')}
        checked={isPrivateModeActive}
        disabled={saving}
        onChange={(event) => onToggle(event.target.checked)}
      />

      <div className={styles.setAll}>
        <span>{t('Set all')}</span>
        <div className={styles.options}>
          {visibilityOptions.map((option) => {
            const inputId = `profile-all-visibility-${option.value}`
            const isChecked =
              option.value === 'public' ? allPublic : allPrivate

            return (
              <label key={option.value} htmlFor={inputId} className={styles.option}>
                <input
                  id={inputId}
                  type="radio"
                  name="profile-all-visibility"
                  value={option.value}
                  checked={isChecked}
                  disabled={saving || modules.length === 0}
                  onChange={() => onSetAllVisibility(option.value)}
                />
                <span>{option.label}</span>
              </label>
            )
          })}
        </div>
      </div>

      <div className={styles.table}>
        <div className={styles.head}>
          <span>{t('Name')}</span>
          <span>{t('Visibility')}</span>
        </div>
        <div className={styles.body}>
          {modules.map((moduleItem) => (
            <div key={moduleItem.code} className={styles.row}>
              <span className={styles.name}>{t(moduleItem.name)}</span>
              <div className={styles.options}>
                {visibilityOptions.map((option) => {
                  const inputId = `profile-${moduleItem.code}-${option.value}`

                  return (
                    <label
                      key={option.value}
                      htmlFor={inputId}
                      className={styles.option}
                    >
                      <input
                        id={inputId}
                        type="radio"
                        name={`profile-${moduleItem.code}-visibility`}
                        value={option.value}
                        checked={moduleItem.visibility === option.value}
                        disabled={saving}
                        onChange={() =>
                          onVisibilityChange(moduleItem.code, option.value)
                        }
                      />
                      <span>{option.label}</span>
                    </label>
                  )
                })}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default PrivateModePanel
